import { Button, FileInput, HTMLSelect, Intent, Spinner } from "@blueprintjs/core"
import React from "react"
import { CommandBarSpacer, StyledFileInput, UploadBarContainer } from "../Reconciliation.styled"

interface UploadBarProps {
  selectedFile: File | null
  onFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  sourceType: string
  onSourceTypeChange: (value: string) => void
  onCompare: () => void
  isLoading: boolean
  canSubmit: boolean
  isSubmitting: boolean
  onSubmit: () => void
}

const SOURCE_OPTIONS = [{ label: "Caceis", value: "caceis" }]

const UploadBar: React.FC<UploadBarProps> = ({
  selectedFile,
  onFileChange,
  sourceType,
  onSourceTypeChange,
  onCompare,
  isLoading,
  canSubmit,
  isSubmitting,
  onSubmit,
}) => {
  return (
    <UploadBarContainer>
      <StyledFileInput>
        <FileInput
          text={selectedFile ? selectedFile.name : "Choose file..."}
          onInputChange={onFileChange}
          inputProps={{ accept: ".xls,.xlsx,.xlsm,.csv" }}
          fill
        />
      </StyledFileInput>
      <HTMLSelect
        value={sourceType}
        onChange={e => onSourceTypeChange(e.target.value)}
        options={SOURCE_OPTIONS}
        minimal
      />
      <Button
        intent={Intent.PRIMARY}
        onClick={onCompare}
        disabled={!selectedFile || isLoading}
        icon={isLoading ? <Spinner size={16} /> : "comparison"}
      >
        {isLoading ? "Comparing..." : "Compare"}
      </Button>
      {/* Submit is the sign-off act — the end of the daily flow, visually
          separated from the load/compare tools on the left. */}
      <CommandBarSpacer />
      <Button
        intent={Intent.SUCCESS}
        onClick={onSubmit}
        disabled={!canSubmit || isSubmitting}
        icon={isSubmitting ? <Spinner size={16} /> : "endorsed"}
      >
        {isSubmitting ? "Submitting..." : "Submit NAV"}
      </Button>
    </UploadBarContainer>
  )
}

export default UploadBar
